var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"no-data"},[_c('img',{attrs:{"src":"https://files.wondercv.com/company/privacy-company-zero.png","alt":""}}),_c('span',[_vm._v(_vm._s(_vm.tooltip))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }